const TUIChat = {
  '查看内容': 'ดูเนื้อหา',
  '立即填写': 'กรอกทันที',
  '已提交': 'ส่งแล้ว',
  '不能为空': 'ต้องไม่ว่างเปล่า',
  '提交': 'ส่ง',
  '撤回': 'ถอนกลับ',
  '删除': 'ลบ',
  '复制': 'คัดลอก',
  '重新发送': 'ส่งใหม่',
  '转发': 'ส่งต่อ',
  '引用': 'อ้างอิง',
  '打开': 'เปิด',
  '已读': 'อ่านแล้ว',
  '未读': 'ยังไม่ได้อ่าน',
  '人已读': 'คนอ่านแล้ว',
  '人未读': 'คนยังไม่ได้อ่าน',
  '人关闭阅读状态': 'คนปิดสถานะการอ่าน',
  '全部已读': 'อ่านทั้งหมดแล้ว',
  '消息详情': 'รายละเอียดข้อความ',
  '关闭阅读状态': 'ปิดสถานะการอ่าน',
  '您': 'คุณ',
  '撤回了一条消息': 'ถอนกลับข้อความหนึ่ง',
  '重新编辑': 'แก้ไขใหม่',
  '我': 'ฉัน',
  '自定义消息': 'ข้อความที่กำหนดเอง',
  '查看更多': 'ดูเพิ่มเติม',
  '确认重发该消息？': 'ยืนยันการส่งข้อความนี้อีกครั้ง?',
  '取消': 'ยกเลิก',
  '确定': 'ยืนยัน',
  '转发给': 'ส่งต่อให้',
  '请输入消息': 'กรุณาใส่ข้อความ',
  '描述': 'คำอธิบาย',
  '经度': 'ลองจิจูด',
  '纬度': 'ละติจูด',
  '图片': '[รูปภาพ]',
  '语音': '[เสียง]',
  '视频': '[วิดีโอ]',
  '表情': '[อีโมจิ]',
  '文件': '[ไฟล์]',
  '自定义': '[ข้อความที่กำหนดเอง]',
  '管理员开启全员禁言': 'ผู้ดูแลระบบเปิดการปิดเสียงทั้งหมด',
  '您已被管理员禁言': 'คุณถูกผู้ดูแลระบบปิดเสียง',
  '按Enter发送': 'กด Enter เพื่อส่ง',
  '单击下载': 'คลิกเพื่อดาวน์โหลด',
  '下载':'ดาวน์โหลด',
  '该消息不存在': 'ข้อความนี้ไม่มีอยู่',
  '无法定位到原消息': 'ไม่สามารถระบุตำแหน่งข้อความต้นฉบับได้',
  '对方正在输入': 'อีกฝ่ายกำลังพิมพ์...',
  '回到最新位置': '',
  '条新消息': 'ข้อความใหม่',
  '点此投诉': 'คลิกที่นี่เพื่อร้องเรียน',
  '语音通话': 'การโทรด้วยเสียง',
  '视频通话': 'การโทรด้วยวิดีโอ',
  '发起群语音': 'เริ่มการโทรด้วยเสียงกลุ่ม',
  '发起群视频': 'เริ่มการโทรด้วยวิดีโอกลุ่ม',
  '已接听': 'รับสายแล้ว',
  '拒绝通话': 'ปฏิเสธการโทร',
  '无应答': 'ไม่มีการตอบรับ',
  '取消通话': 'ยกเลิกการโทร',
  '发起通话': 'เริ่มการโทร',
  '结束群聊': 'สิ้นสุดการแชทกลุ่ม',
  '通话时长': 'ระยะเวลาการโทร',
  '欢迎使用TUICallKit': 'ยินดีต้อนรับสู่การใช้ TUICallKit ของ Tencent Cloud',
  '检测到您暂未集成TUICallKit，无法体验音视频通话功能': 'ตรวจพบว่าคุณยังไม่ได้รวม TUICallKit ไม่สามารถใช้ฟังก์ชันการโทรด้วยเสียงและวิดีโอได้',
  '请点击': 'กรุณาคลิก',
  '集成TUICallKit': 'รวม TUICallKit',
  '开通腾讯实时音视频服务': 'เปิดบริการเสียงและวิดีโอเรียลไทม์ของ Tencent',
  '进行体验': 'เพื่อทดลองใช้',
  '您当前购买使用的套餐包暂未开通此功能': 'แพ็คเกจที่คุณซื้อในปัจจุบันยังไม่ได้เปิดใช้งานฟังก์ชันนี้',
  '系统消息': 'ข้อความระบบ',
  '转人工服务': 'เปลี่ยนเป็นบริการมนุษย์',
  '点击处理': 'คลิกเพื่อดำเนินการ',
  '发送失败': 'ส่งไม่สำเร็จ',
  '复制成功': 'คัดลอกสำเร็จ',
  '回复': 'ตอบกลับ',
  '回复详情': 'รายละเอียดการตอบกลับ',
  '拒绝': 'ปฏิเสธ',
  '聊天记录': 'บันทึกการสนทนา',
  '内容包含敏感词汇': 'เนื้อหามีคำที่ละเมิด',
  '您当前购买使用的套餐包暂未开通群消息已读回执功能': 'แพ็กเกจที่คุณซื้อและใช้ยังไม่เปิดใช้งานฟังก์ชันการแจ้งเตือนอ่านข้อความในกลุ่ม',
  '您当前购买使用的套餐包暂未开通在线用户列表功能': 'แพ็กเกจที่คุณซื้อและใช้ยังไม่เปิดใช้งานฟังก์ชันรายชื่อผู้ใช้ออนไลน์',
  '您有': 'คุณมี',
  '涉及敏感内容': 'เกี่ยวข้องกับเนื้อหาที่ละเมิด',
  '申请加入': 'สมัครเข้าร่วม',
  '条回复': 'ข้อความตอบกลับ',
  '条入群申请': 'คำขอเข้าร่วมกลุ่ม',
  '同意': 'ยอมรับ',
  '图片消息失败,无效的图片格式': 'ส่งข้อความรูปภาพล้มเหลว รูปแบบรูปภาพไม่ถูกต้อง',
  '位置': 'ตำแหน่ง',
  '文件不存在,请检查文件路径是否正确': 'ไม่พบไฟล์ โปรดตรวจสอบที่อยู่ไฟล์ว่าถูกต้องหรือไม่',
  '文件大小超出了限制,如果上传文件,最大限制是100MB': 'ขนาดไฟล์เกินขีดจำกัด หากอัปโหลดไฟล์ ขีดจำกัดสูงสุดคือ 100MB',
  '文件消息失败,禁止发送违规封禁的文件': 'ส่งข้อความไฟล์ล้มเหลว ไม่อนุญาตให้ส่งไฟล์ที่ถูกห้าม',
  '无法查看': 'ไม่สามารถดูได้',
  '无法收听': 'ไม่สามารถฟังได้',
  '正在加载': 'กำลังโหลด',
  '加载结束': 'โหลดเสร็จสิ้น',
  '消息': 'ข้อความ',
  '消息或者资料中文本存在敏感内容,发送失败': 'ข้อความหรือข้อมูลมีเนื้อหาที่ละเมิด ส่งไม่สำเร็จ',
  '消息长度超出限制,消息长度不要超过12K': 'ข้อความยาวเกินขีดจำกัด ความยาวข้อความไม่ควรเกิน 12K',
  '消息中图片存在敏感内容,发送失败': 'รูปภาพในข้อความมีเนื้อหาที่ละเมิด ส่งไม่สำเร็จ',
  '选择提醒的人': 'เลือกบุคคลที่ต้องการแจ้งเตือน',
  '已过撤回时限': 'เกินเวลาการถอนคำสั่ง',
  '已拒绝': 'ปฏิเสธแล้ว',
  '已同意': 'ยอมรับแล้ว',
  '引用失败': 'การอ้างอิงล้มเหลว',
  '翻译': 'แปล',
  '转文字': 'แปลเป็นข้อความ',
  '隐藏': 'ซ่อน',
  '腾讯云 IM': 'Tencent Cloud Chat',
  '空': 'ว่างเปล่า',
  '文本包含本地审核拦截词': 'ข้อความมีคำที่ถูกตรวจสอบและบล็อกในท้องถิ่น',
  '按住说话': 'กดค้างเพื่อพูด',
  '松开发送': 'ยกขึ้นเพื่อส่ง',
  '松手取消': 'ยกขึ้นเพื่อยกเลิก',
  '录音结束提醒': 'ระบบจะหยุดบันทึกในอีก',
  '语音播放失败': 'การเล่นเสียงล้มเหลว',
  '请检查麦克风访问权限': 'กรุณาตรวจสอบสิทธิ์การเข้าถึงไมโครโฟน',
  '按压时间过短，请按压超过1秒': 'กดเวลาสั้นเกินไป โปรดกดค้างไว้เกิน 1 วินาที',
  '正在录音': 'กำลังบันทึกเสียง',
  '继续上滑可取消': 'เลื่อนขึ้นต่อเพื่อยกเลิก',
  '松开手指 取消发送': 'ปล่อยนิ้วเพื่อยกเลิกการส่ง',
  '此机型暂不支持复制功能': 'รุ่นเครื่องนี้ยังไม่รองรับฟังก์ชันคัดลอก',
  '请开通翻译功能': 'โปรดเปิดใช้งานฟังก์ชันแปล',
  '请开通语音转文字功能': 'โปรดเปิดใช้งานฟังก์ชันแปลงเสียงเป็นข้อความ',
  '翻译中': 'กำลังแปล',
  '转换中': 'กำลังแปลง',
  '由IM提供翻译支持': 'รองรับการแปลโดย IM',
  '所有人': 'ทุกคน',
  '已达到表情回应上限数量': 'เต็มจำนวนสูงสุดของการตอบสนองด้วยอารมณ์แล้ว',
  '等': 'และอื่นๆ',
  '人': 'คน',
  '返回': 'ย้อนกลับ',
  '关闭': 'ปิด',
  '多选': 'เลือกหลายรายการ',
  '合并转发': 'รวมการส่งต่อ',
  '逐条转发': 'ส่งต่อทีละรายการ',
  '未选择消息': 'ไม่ได้เลือกข้อความ',
  '[草稿]': '[ร่าง]',
  '[消息]': '[ข้อความ]',
  '[文本]': '[ข้อความ]',
  '[自定义消息]': '[ข้อความที่กำหนดเอง]',
  '[图片]': '[รูปภาพ]',
  '[音频]': '[เสียง]',
  '[语音]': '[เสียง]',
  '[视频]': '[วิดีโอ]',
  '[文件]': '[ไฟล์]',
  '[位置]': '[ตำแหน่ง]',
  '[地理位置]': '[ตำแหน่งทางภูมิศาสตร์]',
  '[动画表情]': '[สติกเกอร์แบบเคลื่อนไหว]',
  '[群提示]': '[เคล็ดลับกลุ่ม]',
  '[群提示消息]': '[ข้อความเคล็ดลับกลุ่ม]',
  '[聊天记录]': '[บันทึกการสนทนา]',
  '[机器人自定义消息]': '[ข้อความที่กำหนดเองของหุ่นยนต์]',
  '引用内容已撤回': 'เนื้อหาที่อ้างถึงถูกเพิกถอนแล้ว',
  '群聊的聊天记录': 'บันทึกการสนทน',
  '和': 'และ',
  '的聊天记录': 'บันทึกการสนทนาของ',
  '请升级IMSDK到v2.10.1或更高版本查看此消息': 'โปรดอัปเกรด IMSDK เป็นเวอร์ชัน 2.10.1 หรือสูงกว่าเพื่อดูข้อความนี้',
  '该群聊已被解散': 'การสนทนากลุ่มนี้ได้ถูกยุบเลิกแล้ว',
  '您已被管理员移出群聊': 'คุณถูกผู้ดูแลระบบเอาออกจากการสนทนากลุ่มแล้ว',
  '您已退出该群聊': 'คุณได้ออกจากการสนทนากลุ่มนี้แล้ว',
  '您已被禁止聊天': 'คุณถูกห้ามสนทนา',
  '按Enter发送，Ctrl+Enter换行': 'กด Enter เพื่อส่ง กด Ctrl+Enter เพื่อขึ้นบรรทัดใหม่',
  '账号被强制下线': 'บัญชีถูกบังคับให้ออกจากระบบ',
  '登录失败': 'เข้าสู่ระบบไม่สำเร็จ',
  '链接':'[ลิงก์]',
};

export default TUIChat;
